module.exports = __webpack_public_path__ + "static/pic02-8dfa0c41640f28a8d1ad5afa4b79855d.jpg";